import type { Board, Value } from "./api.ts";

/** Values with no live open task — the same computation Weekly's reflection and the Board strip both need. */
export function starvingValues(board: Board): Value[] {
  const live = new Set(
    board.tasks.filter((t) => t.state === "open" && !t.blocked && t.value_id).map((t) => t.value_id!),
  );
  return board.values.filter((v) => !live.has(v.key));
}
